import * as React from 'react';
import { Table } from 'antd';
import { VisualMemoryScoresBox } from './VisualRecords.css';
import { getRecords, IRecordScore } from '../api';
import { displayDate, displayTime } from '../../../../../games/functions';
import Flag from "react-flags";
import ShowTime from '../../../../components/ShowTime/ShowTime';

const tColumns = [
    {
        title: 'User',
        dataIndex: 'name',
        render: (name: string, record: IRecordScore) => <>
            <Flag name={record.countryCode} shiny={true} basePath="img/" format="png" pngSize={24} /> {name}
        </>
    },
    {
        title: 'Level',
        dataIndex: 'level',
    },
    {
        title: 'Time',
        dataIndex: 'time',
        render: (time: number) => <ShowTime time={displayTime(time)} sufix='s' />
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: (date: string) => displayDate(date),
    }
];

const VisualRecords = (props: { gameId: number }) => {
    const {gameId} = props;
    const {useState, useEffect} = React;
    const [userScores, setUserScores] = useState<IRecordScore[]>([]);

    useEffect(() => {
        (async function() {
            const scores = await getRecords(gameId);
            setUserScores(scores);
        })();
    }, []);

    return (
        <VisualMemoryScoresBox>
            <Table columns={tColumns} dataSource={userScores} pagination={false} />
        </VisualMemoryScoresBox>
    );
};

export default VisualRecords;